import Vue from 'vue'
import axios from '../plugins/axios'

Vue.prototype.$http = axios

const getDefaultState = () => {
    return {
        search: null,
        selectedCategories: [],
        selectedCommunes: [],
        selectedWebFormStates: [],
        selectedTags: [],
        canSearch: false,
        selectedTourismSectors: [],
        emailSearch: null,
    }
}

const providerFilter = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        setSearch(state, value) {
            state.search = value
        },
        setEmailSearch(state, value) {
            state.emailSearch = value
        },
        setSelectedCategories(state, value) {
            state.selectedCategories = value
        },
        setSelectedCommunes(state, value) {
            state.selectedCommunes = value
        },
        setSelectedWebFormStates(state, value) {
            state.selectedWebFormStates = value
        },
        setSelectedTags(state, value) {
            state.selectedTags = value
        },
        setSelectedTourismSectors(state, value) {
          state.selectedTourismSectors = value
        },
        setCanSearch(state, value) {
            state.canSearch = value
        },
        pushWebFormState(state, value) {
            if(!state.selectedWebFormStates.includes(value)) {
                state.selectedWebFormStates.push(value)
            }
        },
        removeUnavailableStates(state) {
            let availables = ['WITHOUT_EMAIL', 'WITHOUT_WEB_FORM', 'WITHOUT_TAG']

            state.selectedWebFormStates = state.selectedWebFormStates.filter(_state => availables.includes(_state))
        },
        resetState(state) {
            Object.assign(state, getDefaultState())
        }
    }
}

export default providerFilter